import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebf06ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-sidebar-problems" }
const _hoisted_2 = { class: "dw-sidebar-problems__container" }
const _hoisted_3 = { class: "container__entities" }
const _hoisted_4 = {
  key: 0,
  class: "entities__state"
}
const _hoisted_5 = {
  key: 1,
  class: "entities__count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_sidebar_entity = _resolveComponent("dw-sidebar-entity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.computedEntities.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Список пуст"))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, " Количество: " + _toDisplayString(_ctx.computedEntities.length), 1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedEntities, (entity) => {
          return (_openBlock(), _createBlock(_component_dw_sidebar_entity, {
            key: entity.type === 1 ? (entity as DispatcherWorkplaceTake).orderId : (entity as DispatcherWorkplaceDelivery).invoiceId,
            entity: entity,
            "selected-feature-id": _ctx.selectedSidebarFeatureId,
            onClick: _ctx.onEntityClicked
          }, null, 8, ["entity", "selected-feature-id", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}